import $ from 'jquery';
import CMGCalc from './CMGCalc/CMGCalc';
import { defaultValues } from './CMGCalc/dv';

$(async function () {
    const jsonDefaultValues = await defaultValues();

    const mortgagePayment = jsonDefaultValues.mortgagePayment[0];
    const purchasingPower = jsonDefaultValues.purchasingPower[0];
    const qualifyingLoan = jsonDefaultValues.qualifyingLoan[0];
    const rentVsBuy = jsonDefaultValues.rentVsBuy[0];
    const refinance = jsonDefaultValues.refinance[0];
    const fifteenVsThirty = jsonDefaultValues.fifteenVsThirty[0];
    const buyDown = jsonDefaultValues.buyDown;
    const biWeekly = jsonDefaultValues.biWeekly[0];

    const calcDiv = $('[data-dynamic-tab]');
    const calcLink = $('[data-render-link-calc]');
    const calcSingle = $('[data-single-calc]');
    const calcwidget = $('#calculator');

    if (calcDiv.length) {
        const calc = new CMGCalc(calcDiv,
            {
                plugins: false,
                calcMode: calcLink.attr('data-single-calc')
            }, {
            values: {
                Mortgage: {
                    basic: mortgagePayment.basic,
                    advanced: mortgagePayment.advanced
                },
                Purchasing: {
                    basic: purchasingPower.basic,
                    advanced: purchasingPower.advanced
                },
                Qualifying: {
                    monthlyIncome: qualifyingLoan.monthlyIncome,
                    monthlyPayments: qualifyingLoan.monthlyPayments,
                    loanInfo: qualifyingLoan.loanInformation
                },
                RentBuy: {
                    comparableRent: rentVsBuy.comparableRent,
                    homePurchase: rentVsBuy.homePurchase,
                    newLoanInfo: rentVsBuy.newLoanInfo,
                    assumptions: rentVsBuy.assumptions
                },
                Refinance: {
                    currentLoan: refinance.currentLoan,
                    newLoan: refinance.newLoan,
                    accountsToBePaid: refinance.accountsToBePaid
                },
                FifteenThirty: {
                    homeInfo: fifteenVsThirty.homeInfo,
                    shortTermInfo: fifteenVsThirty.shortTermInfo,
                    longTermInfo: fifteenVsThirty.longTermInfo
                },
                Buydown: buyDown,
                BiWeekly: {
                    basic: biWeekly.basic,
                    advanced: biWeekly.advanced
                }
            }
        });
        calc.init();
    }
    if (calcLink.length) {
        var rootPath = calcLink.attr('data-root-url');

        const calc3 = new CMGCalc(calcLink,
            {
                h1:true,
                plugins: false,
                linkNavigate: true,
                calcMode: calcLink.attr('data-render-link-calc')
            },
            {
                links: {
                    Mortgage: rootPath + 'calculator/mortgage-payment',
                    Purchasing: rootPath + 'calculator/purchasing-power',
                    Qualifying: rootPath + 'calculator/qualifying-loan',
                    Rent: rootPath + 'calculator/rent-vs-buy',
                    ShortLong: rootPath + 'calculator/15-vs-30-year-mortgage',
                    Savings: rootPath + 'calculator/refinance',
                    Buydown: rootPath + 'calculator/buy-down',
                    biweeklyMortgage: rootPath + 'calculator/biweekly-payment'
                },
                values: {
                    Mortgage: {
                        basic: mortgagePayment.basic,
                        advanced: mortgagePayment.advanced
                    },
                    Purchasing: {
                        basic: purchasingPower.basic,
                        advanced: purchasingPower.advanced
                    },
                    Qualifying: {
                        monthlyIncome: qualifyingLoan.monthlyIncome,
                        monthlyPayments: qualifyingLoan.monthlyPayments,
                        loanInfo: qualifyingLoan.loanInformation
                    },
                    RentBuy: {
                        comparableRent: rentVsBuy.comparableRent,
                        homePurchase: rentVsBuy.homePurchase,
                        newLoanInfo: rentVsBuy.newLoanInfo,
                        assumptions: rentVsBuy.assumptions
                    },
                    Refinance: {
                        currentLoan: refinance.currentLoan,
                        newLoan: refinance.newLoan,
                        accountsToBePaid: refinance.accountsToBePaid
                    },
                    FifteenThirty: {
                        homeInfo: fifteenVsThirty.homeInfo,
                        shortTermInfo: fifteenVsThirty.shortTermInfo,
                        longTermInfo: fifteenVsThirty.longTermInfo
                    },
                    Buydown: buyDown,
                    BiWeekly: {
                        basic: biWeekly.basic,
                        advanced: biWeekly.advanced
                    }
                }
            }
        );

        calc3.init();
    }

    if (calcSingle.length) {
        const calc2 = new CMGCalc(calcSingle, {
            calcMode: calcSingle.attr('data-single-calc'),
            navigateMode: false,
            footnote: true,
            amortTab: false,
            plugins: false,
            h1:false
        },
            {
                values: {
                    Mortgage: {
                        basic: mortgagePayment.basic,
                        advanced: mortgagePayment.advanced
                    },
                    Purchasing: {
                        basic: purchasingPower.basic,
                        advanced: purchasingPower.advanced
                    },
                    Qualifying: {
                        monthlyIncome: qualifyingLoan.monthlyIncome,
                        monthlyPayments: qualifyingLoan.monthlyPayments,
                        loanInfo: qualifyingLoan.loanInformation
                    },
                    RentBuy: {
                        comparableRent: rentVsBuy.comparableRent,
                        homePurchase: rentVsBuy.homePurchase,
                        newLoanInfo: rentVsBuy.newLoanInfo,
                        assumptions: rentVsBuy.assumptions
                    },
                    Refinance: {
                        currentLoan: refinance.currentLoan,
                        newLoan: refinance.newLoan,
                        accountsToBePaid: refinance.accountsToBePaid
                    },
                    FifteenThirty: {
                        homeInfo: fifteenVsThirty.homeInfo,
                        shortTermInfo: fifteenVsThirty.shortTermInfo,
                        longTermInfo: fifteenVsThirty.longTermInfo
                    },
                    Buydown: buyDown,
                    BiWeekly: {
                        basic: biWeekly.basic,
                        advanced: biWeekly.advanced
                    }
                }
            });

        calc2.init();
    }
})